"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.XL_THRESHOLD = exports.LG_THRESHOLD = void 0;
var XL_THRESHOLD = exports.XL_THRESHOLD = 1200;
var LG_THRESHOLD = exports.LG_THRESHOLD = 992;